import { type FeatureFlagAPI, FeatureFlagRequester } from '@cobliteam/api-lib/src/dashboard/featureFlag';
import { Environment } from '@cobliteam/react-environments';
import { useFlags } from 'launchdarkly-react-client-sdk';
import type FeatureFlags from './featureFlags';
import { featureFlags } from './featureFlags';

const env = Environment.getInstance().getEnvironment();

// Register a feature flag for the current user - /users/feature-flag/{flagKey}/register
type RegisterFunction = (flagKey: keyof FeatureFlags) => Promise<FeatureFlagAPI | undefined>;
const register: RegisterFunction = async (flagKey: keyof FeatureFlags) => {
  const featureFlagRequester = new FeatureFlagRequester({ host: env.apiHost });
  return featureFlagRequester.register(flagKey);
};

// Unregister a feature flag for the current user - /users/feature-flag/{flagKey}/unregister
type UnregisterFunction = (flagKey: keyof FeatureFlags) => Promise<FeatureFlagAPI | undefined>;
const unregister: UnregisterFunction = async (flagKey: keyof FeatureFlags) => {
  const featureFlagRequester = new FeatureFlagRequester({ host: env.apiHost });
  return featureFlagRequester.unregister(flagKey);
};

const useFeatureFlags = (): FeatureFlags & { register: RegisterFunction; unregister: UnregisterFunction } => {
  const { ...flags } = useFlags();

  const filteredFlags = Object.keys(featureFlags).filter((key) => key in flags);

  const responseFlags = filteredFlags.reduce((acc, key) => {
    // @ts-ignore
    acc[key] = flags[key];

    return acc;
  }, {} as FeatureFlags);

  return {
    ...responseFlags,
    register,
    unregister,
  };
};

export { featureFlags };
export type { FeatureFlags };
export default useFeatureFlags;
